import React from 'react';

import { Icon } from '../icons';

export const AnalyticsIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M20.8,20 L23.2,20 C23.6,20 24,19.6 24,19.2 L24,10.8 C24,10.4 23.6,10 23.2,10 L20.8,10 C20.4,10 20,10.4 20,10.8 L20,19.2 C20,19.6 20.4,20 20.8,20 L20.8,20 Z M26.8,20 L29.2,20 C29.6,20 30,19.6 30,19.2 L30,4.8 C30,4.4 29.6,4 29.2,4 L26.8,4 C26.4,4 26,4.4 26,4.8 L26,19.2 C26,19.6 26.4,20 26.8,20 Z M8.8,20 L11.2,20 C11.6,20 12,19.6 12,19.2 L12,14.8 C12,14.4 11.6,14 11.2,14 L8.8,14 C8.4,14 8,14.4 8,14.8 L8,19.2 C8,19.6 8.4,20 8.8,20 Z M14.8,20 L17.2,20 C17.6,20 18,19.6 18,19.2 L18,6.8 C18,6.4 17.6,6 17.2,6 L14.8,6 C14.4,6 14,6.4 14,6.8 L14,19.2 C14,19.6 14.4,20 14.8,20 L14.8,20 Z M31,24 L4,24 L4,5 C4,4.4475 3.5525,4 3,4 L1,4 C0.4475,4 0,4.4475 0,5 L0,26 C0,27.104375 0.895625,28 2,28 L31,28 C31.5525,28 32,27.5525 32,27 L32,25 C32,24.4475 31.5525,24 31,24 Z" />
    </svg>
  );
};
